import { Box } from '@cp/ds/src/components/box';
import { styled } from '@cp/ds/src/theme/styled';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import React, { PropsWithChildren } from 'react';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { ButtonsPanel } from '@cp/ds/src/components/buttonsPanel';
import { StepContainer } from '../stepContainer';

const StyledBox = styled(Box, { name: 'StepFooter' })(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: theme.spacing(2.5),
  '&[data-state="success"]': {
    background: '#F0FAEE',
  },
  '&[data-state="failure"]': {
    background: '#FFF1F1',
  },
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}));

interface StepFooterProps extends PropsWithChildren {
  state?: 'success' | 'failure';
}
export const StepFooter: React.FC<StepFooterProps> = ({ state, children }) => {
  const isMobile = useIsMobile();
  const Wrapper = isMobile ? ButtonsPanel : Box;
  return (
    <StyledBox data-state={state}>
      <Wrapper>
        <StepContainer>{children}</StepContainer>
      </Wrapper>
    </StyledBox>
  );
};
